import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import Typography from '../../atoms/typography';

const ParagraphText = styled(Typography)`
  strong {
    font-weight: bold ;
  }

  ul {
    list-style-type: disc;
    margin: 1rem 0 0 1.75rem;
  }

  b {
    font-weight: bold;
  }
`;

const Descriptions = styled.div`
  color: ${(props) => props.theme.color.brand};
  line-height: 1.5;
  margin-bottom: 3rem;

  ${ParagraphText} + ${ParagraphText} {
    margin-top: 1.5rem;
  }
`;

const ProductDescriptions = (props) => (
  <Descriptions className={props.className}>
    <ParagraphText
      element="p"
      like="paragraph-2"
      dangerouslySetInnerHTML={{ __html: props.description }}
    />

    {
      props.brandDescription && (
        <ParagraphText element="p" like="paragraph-2">
          <b>{`About ${props.brand}: `}</b>
          {props.brandDescription}
        </ParagraphText>
      )
    }

    {props.finalSale && <ParagraphText element="p" like="paragraph-2">Final sale - no returns.</ParagraphText>}
  </Descriptions>
);

ProductDescriptions.defaultProps = {
  brand: '',
  description: '',
  className: '',
  brandDescription: '',
  finalSale: false
};

ProductDescriptions.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  brand: PropTypes.string,
  brandDescription: PropTypes.string,
  finalSale: PropTypes.bool
};

export default ProductDescriptions;
